import BaseApi from "./BaseApi";

export default class PlayerUploadApi extends BaseApi {
  static uploadProspectivePlayers = (year, file) => this.post(`players/import?year=${year}`, file);
}
